"use client";

import { Card, CardContent, CardHeader } from "@workspace/ui/components/card";
import { Skeleton } from "@workspace/ui/components/skeleton";

export function GroupProfileSkeleton() {
	return (
		<div className="container mx-auto max-w-3xl px-4 py-4">
			<div className="flex flex-col gap-3">
				{/* Navigation - exact same as artist */}
				<div className="flex items-center gap-2">
					<Skeleton className="h-8 w-16" />
					<div className="h-4 w-px bg-muted" />
					<Skeleton className="h-5 w-32" />
				</div>

				{/* Profile Card - exact same as artist */}
				<Card className="w-full border bg-card p-3">
					<CardHeader className="p-0">
						<div className="flex gap-4">
							{/* Group photo - 80x80 to match real component */}
							<Skeleton className="h-20 w-20 flex-shrink-0 rounded-lg" />
							<div className="min-w-0 flex-1">
								{/* Group name */}
								<Skeleton className="mb-3 h-7 w-48" />

								{/* Genre badges */}
								<div className="mb-3 flex flex-wrap gap-2">
									<Skeleton className="h-[22px] w-16 rounded-full" />
									<Skeleton className="h-[22px] w-20 rounded-full" />
									<Skeleton className="h-[22px] w-14 rounded-full" />
								</div>

								{/* Stats badges */}
								<div className="mb-3 flex flex-wrap gap-2">
									<Skeleton className="h-[22px] w-16 rounded-full" />
									<Skeleton className="h-[22px] w-20 rounded-full" />
									<Skeleton className="h-[22px] w-18 rounded-full" />
								</div>

								{/* Social media buttons - up to 5 buttons like SocialButtonGroup */}
								<div className="flex gap-2">
									<Skeleton className="h-7 w-7 rounded-xl" />
									<Skeleton className="h-7 w-7 rounded-xl" />
									<Skeleton className="h-7 w-7 rounded-xl" />
									<Skeleton className="h-7 w-7 rounded-xl" />
									<Skeleton className="h-7 w-7 rounded-xl" />
								</div>
							</div>
						</div>
					</CardHeader>
				</Card>

				{/* Member cards skeleton - unique to groups */}
				<div className="grid grid-cols-2 gap-3">
					{[1, 2].map((id) => (
						<Card key={`member-skeleton-${id}`} className="overflow-hidden">
							<CardContent className="p-3">
								<div className="flex items-start gap-3">
									<Skeleton className="h-12 w-12 flex-shrink-0 rounded-lg" />
									<div className="min-w-0 flex-1">
										<Skeleton className="mb-1 h-4 w-24" />
										<Skeleton className="h-3 w-16" />
									</div>
								</div>
							</CardContent>
						</Card>
					))}
				</div>

				{/* Tabs skeleton - only 2 tabs for groups */}
				<Skeleton className="h-10 w-full rounded-lg" />

				{/* Filter row skeleton */}
				<div className="space-y-3">
					<div className="flex items-center gap-3">
						<Skeleton className="h-10 flex-1" />
						<Skeleton className="h-10 flex-1" />
					</div>
					<Skeleton className="h-10 w-full" />
				</div>

				{/* Content cards skeleton - exact same as artist */}
				<div className="space-y-3">
					{[1, 2, 3, 4, 5].map((id) => (
						<Card key={`group-content-skeleton-${id}`}>
							<CardContent className="p-3">
								<div className="flex gap-3">
									{/* Festival poster - correct aspect ratio h-16 w-12 (3:4) */}
									<Skeleton className="h-16 w-12 flex-shrink-0 rounded-md" />
									<div className="min-w-0 flex-1">
										{/* Primary text (festival/show name) */}
										<Skeleton className="mb-2 h-5 w-48" />
										{/* Secondary text (stage/venue) */}
										<Skeleton className="mb-1 h-4 w-32" />
										{/* Time/date */}
										<Skeleton className="mb-1 h-4 w-28" />
										{/* Additional info */}
										<Skeleton className="h-4 w-24" />
									</div>
								</div>
							</CardContent>
						</Card>
					))}
				</div>
			</div>
		</div>
	);
}
